import React from 'react';
import { Box, Typography } from '@mui/material';
import { Event } from 'services/api';
import { CHECK_IN_COLORS } from './colors';
import { formatEventDateLabel, formatEventTimeRange } from './format';

export const EventBlock: React.FC<{ event: Event }> = ({ event }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '7px',
      alignItems: 'center',
      justifyContent: 'center',
      pb: '14px',
      width: '100%',
      textAlign: 'center',
      color: CHECK_IN_COLORS.text,
    }}
  >
    <Typography
      sx={{
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '23px',
        width: '100%',
      }}
    >
      {event.name}
    </Typography>
    <Typography
      sx={{
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '21px',
        width: '100%',
      }}
    >
      {formatEventDateLabel(event.date)}
    </Typography>
    <Typography
      sx={{
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '21px',
        width: '100%',
      }}
    >
      {formatEventTimeRange(event.startTime, event.endTime)}
    </Typography>
  </Box>
);

export const DashedDivider: React.FC = () => (
  <Box
    sx={{
      height: '16px',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        borderTop: `1px dashed ${CHECK_IN_COLORS.muted}`,
      }}
    />
  </Box>
);
